import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';
import { AuthContext } from '../context/AuthContext';

const Profile = () => {
  const { user, updateProfile, changePassword } = useContext(AuthContext);

  const [profileData, setProfileData] = useState({
    phone: user?.phone || '',
    email: user?.email || '',
    companyName: user?.companyName || ''
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [profileLoading, setProfileLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(profileData.email)) {
      toast.error('Dogry email adresini giriziň');
      return;
    }

    const updatedFields = {};
    if (profileData.email !== user.email) updatedFields.email = profileData.email;
    if (profileData.companyName !== user.companyName) updatedFields.companyName = profileData.companyName;

    if (Object.keys(updatedFields).length === 0) {
      toast.info('Üýtgeşiklik ýok');
      return;
    }

    setProfileLoading(true);
    NProgress.start();

    const success = await updateProfile(updatedFields);

    setProfileLoading(false);
    NProgress.done();
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    const { currentPassword, newPassword, confirmPassword } = passwordData;

    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error('Ähli meýdançalary dolduryň');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('Täze açar sözler biri-birine gabat gelmeýär');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('Täze açar söz azyndan 6 simwoldan ybarat bolmaly');
      return;
    }

    setPasswordLoading(true);
    NProgress.start();

    const success = await changePassword({ currentPassword, newPassword });

    if (success) {
      toast.success('Açar söz üstünlikli üýtgedildi');
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    }

    setPasswordLoading(false);
    NProgress.done();
  };
  NProgress.start();
  NProgress.done();
  return (
    <>
      <Helmet>
        <title>SMS Serwis - Hasap</title>
      </Helmet>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Profile Update */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Ulanyjy hasap maglumatlary</h2>
          <form onSubmit={handleProfileSubmit}>
            <div className="mb-4">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Telefon belgi:</label>
              <div className="flex items-center gap-2">
                <span>+993</span>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={profileData.phone}
                  className="mt-1 block w-full rounded-md border-gray-300 bg-gray-50 shadow-sm"
                  disabled
                />
              </div>
              <p className="mt-1 text-xs text-gray-500">Telefon belgini üýtgedip bolmaýar</p>
            </div>


            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-mail poçta:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={profileData.email}
                onChange={handleProfileChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring focus:ring-indigo-200"
                disabled={profileLoading}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="companyName" className="block text-sm font-medium text-gray-700">Kompaniýa ady:</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={profileData.companyName}
                onChange={handleProfileChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring focus:ring-indigo-200"
                disabled={profileLoading}
              />
            </div>

            <button
              type="submit"
              className="mt-2 w-full inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
              disabled={profileLoading}
            >
              {profileLoading ? 'Ýatda saklanýar...' : 'Ýatda sakla'}
            </button>
          </form>
        </div>

        {/* Password Update */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Açar sözi üýtget</h2>
          <form onSubmit={handlePasswordSubmit}>
            <div className="mb-4">
              <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700">Häzirki açar söz:</label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                value={passwordData.currentPassword}
                onChange={handlePasswordChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                disabled={passwordLoading}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">Täze açar söz:</label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={passwordData.newPassword}
                onChange={handlePasswordChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                disabled={passwordLoading}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Täze açar sözi tassykla:</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handlePasswordChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                disabled={passwordLoading}
              />
            </div>

            <button
              type="submit"
              className="mt-2 w-full inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
              disabled={passwordLoading}
            >
              {passwordLoading ? 'Üýtgedilýär...' : 'Açar sözi üýtget'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Profile;
